import PlatformNotificationParamsInterface from "~/operatorApplication/ts/platform/PlatformNotificationParamsInterface";

export default abstract class AbstractPlatformNotification {
    abstract show(p: PlatformNotificationParamsInterface): void;

    abstract closeByGroupId(groupId: string): void;

    abstract hasByGroupId(groupId: string): boolean;

    abstract closeAll(): void;

    abstract reposition(): void;
}
